import styled from "@emotion/styled";
import { useDeepCompareMemo } from "@react-hookz/web";

import type { ContentSchemaRenderProps } from "scmp-app/components/schema-render/content";

import type { ExtraProps } from ".";
import { Image as ContentSchemaRenderImage } from ".";

const getRenderImageComponent = (extraProps: ExtraProps) => {
  const Component = (p: ContentSchemaRenderProps) => (
    <ContentSchemaRenderImage {...p} {...extraProps} />
  );
  return styled(Component)``;
};

export function useContentSchemaRenderImage(extraProps: ExtraProps) {
  const ComponentWithExtraProps = useDeepCompareMemo(
    () => getRenderImageComponent(extraProps),
    [extraProps],
  );

  return {
    ComponentWithExtraProps,
  };
}
